module.exports = __webpack_public_path__ + "img/up1.c323eef7.png";